<template>
  <div class="portfolio-tracker-status-panel">
    <p class="portfolio-tracker-status-panel__sentence">
      <strong>{{ statusSentence }}</strong>
    </p>
    <p
      v-if="arrivalDateText"
      class="portfolio-tracker-status-panel__arrival"
    >
      <em>{{ arrivalDateText }}</em>
    </p>
    <a
      v-if="trackingLink"
      :href="trackingLink"
      target="_blank"
      rel="noopener noreferrer"
      class="portfolio-tracker-status-panel__track-link"
    >
      {{ trackLinkLabel }}
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

// Purely presentational status panel. All copy (status sentence per
// display-stage, arrival-date sentence with date already substituted,
// track-link URL + label) comes in as resolved-string props from the parent
// `PortfolioTrackerModal`, which owns the content + substitution logic.
export default defineComponent({
  name: 'PortfolioTrackerStatusPanel',
  props: {
    statusSentence: {
      type: String,
      required: true
    },
    arrivalDateText: {
      type: String as PropType<string | null>,
      default: null
    },
    trackingLink: {
      type: String as PropType<string | null>,
      default: null
    },
    trackLinkLabel: {
      type: String,
      required: true
    }
  }
})
</script>

<style scoped lang="scss">
.portfolio-tracker-status-panel {
  font-size: 0.875rem;
  color: #000;

  @include media-breakpoint-up(md) {
    font-size: 1rem;
  }

  &__sentence {
    margin: 0 0 0.25rem;
  }

  &__arrival {
    margin: 0 0 0.5rem;
  }

  &__track-link {
    color: inherit;
    font-weight: 700;
    text-decoration: underline;

    &:hover {
      color: #bb4a92;
    }
  }
}
</style>
